import { render, staticRenderFns } from "./AgendaSpecializzazioniListComponent.vue?vue&type=template&id=33a1cd19"
import script from "./AgendaSpecializzazioniListComponent.vue?vue&type=script&lang=js"
export * from "./AgendaSpecializzazioniListComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaSpecializzazioniListComponent.vue?vue&type=style&index=0&id=33a1cd19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports